// extracted by mini-css-extract-plugin
module.exports = {"wave":"styles__wave___2-5ck","waveInverted":"styles__waveInverted___26Rvl"};